import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import i18n from './i18n'

// Vue.config.productionTip = false
// Vue.config.devtools = true


Vue.mixin({ 
  data() {
    return {

    }
  },

  methods: {
    setNewLanguage() {
      this.$i18n.locale = this.pickedLanguage
    }
  },
  computed: {
    pickedLanguage: {
      get () { 
        return this.$store.state.language 
      }
    }
  }
})

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
})
.$mount('#app')

/* SAPSF-9929 safety to always replace the area-label */
setTimeout(() => {
  const button = document.querySelector('button.v-icon.mdi-plus[aria-label="prepend icon"]');
  if (button) {
    button.setAttribute('aria-label', 'Weitere Dateien hinzufügen / Add another file');
  }
}, 500);